var React = require('react');

function ModalClose (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20.5","cy":"20","r":"19.5","fill":"white","stroke":"#3872E9","key":0}),React.createElement("rect",{"x":"14.1309","y":"13.4233","width":"18.4055","height":"1","transform":"rotate(45 14.1309 13.4233)","fill":"#3872E9","key":1}),React.createElement("rect",{"x":"14.0366","y":"26.6005","width":"18.4055","height":"1","transform":"rotate(-45 14.0366 26.6005)","fill":"#3872E9","key":2})]);
}

ModalClose.defaultProps = {"width":"41","height":"40","viewBox":"0 0 41 40","fill":"none"};

module.exports = ModalClose;

ModalClose.default = ModalClose;
